import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { reviewData } from "../../sample-data";


const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchReview = createAsyncThunk(
  "Review/fetchReview",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 1000));    
    return reviewData;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReview = createSlice({
  name: "Review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReview.pending, (state) => {
        state.data = [];
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchReview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchReview.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectReviewData = (state) => state.Review.data;
export const selectIsLoading = (state) => state.Review.isLoading;
export const selectError = (state) => state.Review.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.Review.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.Review.data,
  isLoading: state.Review.isLoading,
  error: state.Review.error,
}));
*/
export default sliceReview.reducer; // Export the reducer
